import React, { Component } from "react";
import AuthService from "../services/auth.service";
import UploadService from "../services/upload.service";
import '../css/data_managment.css';
import authService from "../services/auth.service";

export default class DataManagment extends Component {

    constructor(props) {
        super(props);
        this.handleUpload = this.handleUpload.bind(this);
        this.handleFileChange = this.handleFileChange.bind(this);
        this.state = {
            messageRegle: "",
            messageCorrespondance: "",
            redirect: "",
            selectedFileRegle: "",
            selectedFileCorrespondance: "",
            successfulcorrespondance: false,
            successfulregle: false,
            type:"",
            loading: false
        };


    }

    handleUpload(){
            const formData = new FormData();
            let  select = this.state.type === "regle" ? this.state.selectedFileRegle : this.state.selectedFileCorrespondance;
            this.setState({loading: true});
            formData.append('file', select);
            UploadService.uploadCsv(formData,this.state.type).then(
            response => {
                if(this.state.type === "regle") {
                    this.setState({
                        messageRegle: response.data,
                        successfulRegle: true,
                        messageCorrespondance: "",
                        successfulCorrespondance: false,
                        selectedFileRegle: false
                    });
                    document.getElementById("file-regle").value = '';

                }else{
                    this.setState({
                        messageCorrespondance: response.data,
                        successfulCorrespondance: true,
                        messageRegle: "",
                        successfulRegle: false,
                        selectedFileCorrespondance:false
                    });
                    document.getElementById("file-correspondance").value = '';

                }
                this.setState({loading: false});
            },
            error => {
                if(this.state.type === "regle") {
                    this.setState({
                        messageRegle: error.response.data,
                        successfulRegle: false,
                        messageCorrespondance: "",
                        successfulCorrespondance: false,
                    });
                }else{
                    this.setState({
                        messageCorrespondance: error.response.data,
                        successfulCorrespondance: false,
                        messageRegle: "",
                        successfulRegle: false
                    });
                }
                this.setState({loading: false});

            }
        );



    }
    handleFileChange(event) {
        let type = event.target.dataset.typefile;
        if(type === 'regle') {
            this.setState({selectedFileRegle: event.target.files[0],
                selectedFileCorrespondance:"", type:"regle" });
        }else{
            this.setState({selectedFileCorrespondance: event.target.files[0],
                selectedFileRegle:"", type:"correspondance"});
        }

    }

    componentDidMount() {
        const currentUser = AuthService.getCurrentUser();
        if (!currentUser || currentUser.roles[0]!=="ROLE_ADMIN") {
            authService.logout();
        }
    }

    render() {

        return (
            <div className="col-md-12">
                <header className="jumbotron">
                    <h3>
                        <strong>Gestion des données </strong>
                    </h3>
                </header>
                <div className="App">
                    <div className="jumbotron">
                    <div className="mb-3">
                        <label htmlFor="file-correspondance" className="form-labe title-form-import-file">Tableau de correspondance pour afficher l'étape du recouvrement</label>
                        <input type="file" className="form-control file" ref="file-correspondance" id="file-correspondance" data-typefile="correspondance" onChange={this.handleFileChange}/>
                    </div>
                    <div className="mb-3">
                        <button className=" btn-ohm btn btn-primary" onClick={this.handleUpload}  disabled={!this.state.selectedFileCorrespondance}>
                            Importer
                            {(this.state.loading===true && this.state.selectedFileCorrespondance ) && (
                                <span className="spinner-border spinner-border-sm"></span>
                            )}
                        </button>
                        <a className=" btn-ohm btn btn-primary" href={'/recovery_stage'} >
                            Consulter la liste des étapes du recouvrement
                        </a>
                    </div>
                    {this.state.messageCorrespondance && (
                        <div className="form-group">
                            <div
                                className={
                                    this.state.successfulCorrespondance
                                        ? "alert alert-success"
                                        : "alert alert-danger"
                                }
                                role="alert"
                            >
                                {this.state.messageCorrespondance}
                            </div>
                        </div>
                    )}
                    </div>

                    <div className="jumbotron" >
                    <div className="mb-3">
                        <label htmlFor="file-regle" className="form-labe title-form-import-file">Tableau des règles de gestion du recouvrement</label>
                        <input type="file" className="form-control file" ref="file-regle" id="file-regle" data-typefile="regle" onChange={this.handleFileChange}/>
                    </div>
                    <div className="mb-3">
                        <button className=" btn-ohm btn btn-primary" onClick={this.handleUpload}  disabled={!this.state.selectedFileRegle}>
                            Importer
                            {(this.state.loading===true && this.state.selectedFileRegle) && (
                                <span className="spinner-border spinner-border-sm"></span>
                            )}
                        </button>
                        <a className=" btn-ohm btn btn-primary" href={"/recovery_rules"} >
                            Consulter la liste des règles appliquées
                        </a>

                    </div>
                    {this.state.messageRegle && (
                        <div className="form-group">
                            <div
                                className={
                                    this.state.successfulRegle
                                        ? "alert alert-success"
                                        : "alert alert-danger"
                                }
                                role="alert"
                            >
                                {this.state.messageRegle}
                            </div>
                        </div>
                    )}
                </div>
                </div>



            </div>


        );

    }

}
